const testimonials = [
  {
    name: "Emma L.",
    location: "Norman, OK — OU Student",
    rating: 5,
    text: "Got my first passport in 5 days for my OU Jerusalem Center program. The checklist they sent made the Norman Post Office visit incredibly easy. I was panicking because I got accepted late and my program started in two weeks. Fast Passport Center made it happen.",
    service: "First-Time Passport",
  },
  {
    name: "Dr. James W.",
    location: "OU Health, Norman",
    rating: 5,
    text: "Needed a passport for a WHO conference in Geneva. Fast Passport Center handled everything in 4 days while I was on call. I did not have time to visit a regional agency myself — they took care of the entire submission process. Incredible service.",
    service: "Emergency Renewal",
  },
  {
    name: "The Patel Family",
    location: "Norman, OK",
    rating: 5,
    text: "Family of 4 — all passports renewed for our India trip. They coordinated everything and we had passports back in 8 days. Two of our kids had expired passports we did not even know about. They caught it, guided us through the child requirements, and saved our vacation planning!",
    service: "Family Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function NormanTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Norman &amp; Cleveland County Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Norman, OU students, OU Health professionals, and local families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}